module.exports = __webpack_public_path__ + "media/images/bag-icon-d48ff655f3d49e762b24f825b2ea3c65.svg";